export enum Brand {
  all = 'all',
  astrowoche = 'astrowoche',
  autozeitung = 'autozeitung',
  bravo = 'bravo',
  cosmopolitan = 'cosmopolitan',
  happinez = 'happinez',
  intouch = 'intouch',
  lecker = 'lecker',
  liebenswert = 'liebenswert',
  maennersache = 'maennersache',
  praxisvita = 'praxisvita',
  selbst = 'selbst',
  tvmovie = 'tvmovie',
  whitelabel = 'whitelabel',
  wunderweib = 'wunderweib'
}

export const isBrand = (value: unknown): value is Brand => {
  return typeof value === 'string' && Object.values(Brand).some(brand => brand === value)
}
